#import "../fragments/email-list-item-fragment.graphql"

query GetFailedEmails($limit: Int!, $cursor: String) {
    failedEmails(first: $limit, after: $cursor) {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
        }
        edges {
            cursor
            node {
                ...EmailListItem
            }
        }
    }
}
